import React from 'react';
import { Link, Typography } from '@mui/material';

export interface AccountHistoryHeaderProps {
  titleVariant?: 'h4' | 'h5';
}

const AccountHistoryHeader: React.FC<AccountHistoryHeaderProps> = ({ titleVariant = 'h4' }) => {
  return (
    <>
      <Typography variant={titleVariant} gutterBottom>
        Qix Credits Account History
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Qix Credits are platform reward points, not cash or legal tender. Redemption of credits into cash is limited to only{' '}
        <Link
          href="https://qixit.com/redemption-program/"
          target="_blank"
          rel="noopener noreferrer"
        >
          eligible users
        </Link>
        . See{' '}
        <Link
          href="https://qixit.com/terms-of-use/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </Link>{' '}
        (Last Updated: March 18, 2026).
      </Typography>
    </>
  );
};

export default AccountHistoryHeader;
